"use strict";

exports.__esModule = true;
exports.default = void 0;
// constants
var minuteInMilliseconds = 60 * 1000;
var hourInMilliseconds = minuteInMilliseconds * 60;
var dayInMilliseconds = hourInMilliseconds * 24; // conversion helpers

var msToSeconds = function msToSeconds(ms) {
  return ms / 1000;
};

var msToMinutes = function msToMinutes(ms) {
  return Math.floor(msToSeconds(ms) / 60);
};

var msToHours = function msToHours(ms) {
  return Math.floor(msToMinutes(ms) / 60);
};

var msToDays = function msToDays(ms) {
  return Math.floor(msToHours(ms) / 24);
};

var secondsToMs = function secondsToMs(seconds) {
  return seconds * 1000;
};

var minutesToMs = function minutesToMs(minutes) {
  return secondsToMs(60 * minutes);
};

var hoursToMs = function hoursToMs(hours) {
  return minutesToMs(60 * hours);
};

var daysToMs = function daysToMs(days) {
  return hoursToMs(24 * days);
};

function Duration(milliseconds, largestUnit) {
  if (milliseconds === void 0) {
    milliseconds = 0;
  }

  if (largestUnit === void 0) {
    largestUnit = 'hours';
  }

  var ms = Math.abs(milliseconds);
  var unitRepresentation = largestUnit;
  return {
    addSeconds: function addSeconds(seconds) {
      ms += secondsToMs(seconds);
    },
    addMinutes: function addMinutes(minutes) {
      ms += minutesToMs(minutes);
    },
    addHours: function addHours(hours) {
      ms += hoursToMs(hours);
    },
    addDays: function addDays(days) {
      ms += daysToMs(days);
    },
    getDays: function getDays() {
      return msToDays(ms);
    },
    getHours: function getHours() {
      var remainingHoursMs = ms % dayInMilliseconds;
      return msToHours(remainingHoursMs);
    },
    getMinutes: function getMinutes() {
      var remainingMinutesMs = ms % hourInMilliseconds;
      return msToMinutes(remainingMinutesMs);
    },
    getSeconds: function getSeconds() {
      var remainingSecondsMs = ms % minuteInMilliseconds;
      return msToSeconds(remainingSecondsMs);
    },
    getDuration: function getDuration() {
      switch (unitRepresentation) {
        case 'days':
          {
            return {
              days: this.getDays(),
              hours: this.getHours(),
              minutes: this.getMinutes(),
              seconds: this.getSeconds()
            };
          }

        case 'minutes':
          {
            return {
              minutes: msToMinutes(ms),
              seconds: this.getSeconds()
            };
          }

        case 'seconds':
          {
            return {
              seconds: msToSeconds(ms)
            };
          }

        default:
          {
            return {
              hours: msToHours(ms),
              minutes: this.getMinutes(),
              seconds: this.getSeconds()
            };
          }
      }
    },

    get milliseconds() {
      return ms;
    },

    set milliseconds(value) {
      ms = Math.abs(value);
    }

  };
}

var _default = Duration;
exports.default = _default;